import React, { useCallback, useEffect, useState } from "react";
import {
  parseAmount,
  CURRENCY_EURO,
  addHtmlElementClass,
  removeHtmlElementClass,
  scrollHtmlElementIntoView,
  saleItemColorState,
  isDefined,
  convertToLocal,
  setHtmlElementContent,
  parseDateIsoFormat,
  MEDIUM_DEBOUNCE_TIME,
  enableHtmlElement,
  pluralize,
  generateRandomNumber,
  appendHtmlElementChild,
  getHtmlElement,
} from "../../utils/utils";
import I18n from "i18n-js";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import SaleForm from "./SaleForm";
import ErrorModal from "./ErrorModal";
import IconTooltip from "./IconTooltip";
import moment from "moment";
import { debounce, isEqual } from "lodash";
import SaleItemHappyEnding from "./SaleItemHappyEnding";
import AlertPopup from "./AlertPopup";
import SuccessFlashMessage from "./SuccessFlashMessage";
import Modal from "react-bootstrap/Modal";
import SaleItemDeletedHappyEnding from "./SaleItemDeletedHappyEnding";
import GradingCertificate from "./GradingCertificate";




const SaleItemDetails = ({
  saleItem
}) => {

  return (
    <React.Fragment>
      <div className="d-flex justify-content-center justify-content-md-start line-height-normal-imp text-lg-truncate">
        <b className="text-lg-truncate">{saleItem.blueprint_image.en_name ? saleItem.blueprint_image.en_name : saleItem.blueprint_image.meta_name}</b>
      </div>

      <div className="d-flex flex-lg-nowrap flex-sm-wrap justify-content-around justify-content-md-end">
        {
          saleItem.sale_method &&
          <IconTooltip
            tooltipContent={I18n.t('js.indexSaleItems.saleMethod')}
            customComponentToRender={
              <React.Fragment>
                <div
                  className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
                  <img src={window.location.origin + `/images/icons/small/sale_item_${saleItem.sale_method.toLowerCase()}.svg`}
                    alt="" width="15" height="15" className="mr-1" />
                  <div>
                    {I18n.t(`js.indexSaleItems.saleMethods.${saleItem.sale_method}`).toUpperCase()}
                  </div>
                </div>
              </React.Fragment>
            }
          />
        }

        {
          ((isDefined(saleItem.amount) && saleItem.amount > 0) || (isDefined(saleItem.start_amount) && saleItem.start_amount > 0)) &&
          <IconTooltip
            tooltipContent={I18n.t(`js.indexSaleItems.amount.amount${saleItem.sale_method ? '_' + saleItem.sale_method : ''}_extended`)}
            customComponentToRender={
              <React.Fragment>
                <div
                  className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
                  <img src={window.location.origin + '/images/icons/small/money.svg'}
                    alt="" width="15" height="15" className="mr-2" />
                  <div>
                    {parseAmount(saleItem.amount ? saleItem.amount : saleItem.start_amount, 2, true)}{CURRENCY_EURO}
                  </div>
                </div>
              </React.Fragment>
            }
          />
        }

        {
          saleItem.state !== 'draft' && isDefined(saleItem.offers_count) &&
          <IconTooltip
            tooltipContent={pluralize(saleItem.offers_count, 'indexSaleItems.offersCount').replace(":offers_count", saleItem.offers_count.toString())}
            customComponentToRender={
              <React.Fragment>
                <div
                  className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
                  <img src={window.location.origin + '/images/icons/small/balls.svg'}
                    alt="" width="15" height="15" className="mr-2" />
                  <div>
                    {saleItem.offers_count}
                  </div>
                </div>
              </React.Fragment>
            }
          />
        }

        <IconTooltip
          tooltipContent={I18n.t('js.indexSaleItems.initializationDate')}
          customComponentToRender={
            <React.Fragment>
              <div
                className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
                <img src={window.location.origin + '/images/icons/small/calendar.svg'}
                  alt="" width="15" height="15" className="mr-2" />
                <div className="line-height-normal-imp">
                  {saleItem.initialized_at}
                </div>
              </div>
            </React.Fragment>
          }
        />
      </div>
    </React.Fragment>
  )
}



const SaleItemActionButton = ({
  condition,
  button
}) => {

  return (
    condition &&
    <React.Fragment>
      {button}
    </React.Fragment>
  )
}


const SaleItemsList = ({
  saleItems,
  setSaleItems,
  saleItemsAnimationDivider,
  saleItemsCount,
  setSaleItemsCount,
  saleChannelsLinks
}) => {

  const now = moment().local();
  const [saleItemToUpdate, setSaleItemToUpdate] = useState({ oldSaleItem: null, updatedSaleItem: null })
  const [deferredListingToSubmit, setDeferredListingToSubmit] = useState(null);
  const [initCompleted, setInitCompleted] = useState(null)
  const [saleItemToShowGradingCertificate, setSaleItemToShowGradingCertificate] = useState(null);
  const [saleItemToDestroy, setSaleItemToDestroy] = useState(null);
  const [saleItemToPublish, setSaleItemToPublish] = useState(null);
  const [feesAlertRead, setFeesAlertRead] = useState(JSON.parse(window.localStorage.getItem('feesAlertRead')));
  const [showSuccessFlashMessage, setShowSuccessFlashMessage] = useState(false);
  const [showCertificate, setShowCertificate] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  // console.log('saleItems: ', saleItems);


  useEffect(() => {
    if (!initCompleted)
      setInitCompleted(true);
  }, [])

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateSaleItem();
      return debouncedUpdateSaleItem.cancel;
    }
  }, [saleItemToUpdate, debouncedUpdateSaleItem]);

  useEffect(() => {
    if (isDefined(deferredListingToSubmit)) {
      const channelLink = saleChannelLink(deferredListingToSubmit.saleItem);
      if (channelLink?.state === 'completed')
        handleUpdateSaleItem(deferredListingToSubmit.saleItem, deferredListingToSubmit.listingAction, deferredListingToSubmit.ingnoreFeesAlert);
    }
  }, [saleChannelsLinks])


  // Funzione che esegue l'update debouncato di uno specifico sale item
  const debouncedUpdateSaleItem = useCallback(
    debounce(() => {
      if (saleItemToUpdate?.updatedSaleItem &&
        (saleItemToUpdate.updatedSaleItem.start_amount != saleItemToUpdate.oldSaleItem?.start_amount ||
          !isEqual(saleItemToUpdate.updatedSaleItem.sale_attributes, saleItemToUpdate.oldSaleItem?.sale_attributes) ||
          !isEqual(saleItemToUpdate.updatedSaleItem.shipment_method, saleItemToUpdate.oldSaleItem?.shipment_method))) {
        handleUpdateSaleItem(saleItemToUpdate.updatedSaleItem);
      }
    }, MEDIUM_DEBOUNCE_TIME),
    [saleItemToUpdate]
  );


  // Funzione che aggiorna un determinato annuncio di vendita sull'interfaccia grafica
  const handleUpdateSaleItemParams = (saleItem) => {
    let newSaleItems = saleItems.map((sale_item) => {
      return sale_item.id === saleItem.id ? { ...saleItem } : sale_item
    });
    setSaleItems(newSaleItems);
  }


  // Funzione che annulla le modifiche apportate a un certo annuncio di vendita post-pubblicazione
  const handleRevertSaleItem = (saleItem) => {
    const url = `/users/${saleItem.user_id}/sale_items/${saleItem.id}.json`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }
    })
      .then((res) => {
        if (!res.ok)
          throw Error("An error occour during getting data from database");
        else
          return res.json()
      })
      .then((data) => {
        handleUpdateSaleItemParams({ ...data });
      })
      .catch((error) => {
        console.log(error);
        setShowErrorModal(true);
      });
  }


  // Funzione che gestisce la cancellazione di un annuncio di vendita dal relativo sale channel
  const handleDeleteSaleItem = (saleItem) => {
    if (saleItem.state === 'draft')
      handleUpdateSaleItem(saleItem, 'delete');
    else
      setSaleItemToDestroy(saleItem)
  }


  // Funzione che ritorna tutti i sale attributes di un sale item sulla base del metodo di vendito impostato su di esso
  const saleAttributesBySaleItem = (saleItem) => {
    return saleItem.sale_channel.sale_attributes.no_sale_method.concat(saleItem.sale_method && saleItem.sale_channel.sale_attributes[saleItem.sale_method] ? saleItem.sale_channel.sale_attributes[saleItem.sale_method] : []);
  }


  // Funzione che renderizza sull'interfaccia grafica un activity indicator che segnala all'utente che è in corso una
  // chiamata http al server per pubblicare o modificare un annuncio di vendita che potrebbe richiedere qualche istante
  // per essere completata
  const handleShowActivityIndicator = (saleItem, show, listingAction) => {
    if (isDefined(listingAction)) {
      if (show) {
        for (const action of ['revert', 'delete', 'publish', 'update', 'edit'])
          removeHtmlElementClass(document, `activity_indicator_${saleItem.id}`, 'd-none');
        addHtmlElementClass(document, `activity_indicator_${saleItem.id}`, 'd-flex');
        setHtmlElementContent(document, `activity_indicator_${saleItem.id}_message`, I18n.t(`js.indexSaleItems.listingForm.activityIndicator.${listingAction}`))
      }
      else {
        for (const action of ['revert', 'delete', 'publish', 'update', 'edit'])
          removeHtmlElementClass(document, `activity_indicator_${saleItem.id}`, 'd-flex');
        addHtmlElementClass(document, `activity_indicator_${saleItem.id}`, 'd-none');
      }

      for (const saleAttribute of saleAttributesBySaleItem(saleItem))
        enableHtmlElement(document, `sale_attribute_${saleAttribute?.trait_name}_${saleItem.id}`, !show);
      enableHtmlElement(document, `sale_method_${saleItem.id}`, !show);
      enableHtmlElement(document, `start_amount_${saleItem.id}`, !show);
      enableHtmlElement(document, `shipment_method_select_${saleItem.id}`, !show);
      enableHtmlElement(document, `national_shipment_method_${saleItem.id}`, !show);
      enableHtmlElement(document, `international_shipment_method_${saleItem.id}`, !show);
      enableHtmlElement(document, `national_shipment_method_amount_${saleItem.id}`, !show);
      enableHtmlElement(document, `international_shipment_method_amount_${saleItem.id}`, !show);
    }
  }

  // Redirigo l'utente al link del suo saleItem oppure lo cancello se possibile
  const handleRedirectSaleItemToDelete = (saleItem) => {
    if (saleItemToDestroy?.sale_channel?.sale_methods?.filter(sale_method => sale_method.method == saleItemToDestroy.sale_method)[0]?.enable_deletion) {
      handleUpdateSaleItem(saleItem, 'delete')
    } else {
      if (saleItem.listing_url)
        window.location.href = saleItem.listing_url
      else
        setSaleItemToDestroy(null)
    }
  }

  const handleCloseDeletedSaleItemNotice = (saleItem) => {
    let newSaleItems = saleItems.filter((sale_item) => sale_item.id != saleItem.id);
    if (newSaleItems?.length === 0)
      window.location = window.location.href.split('?')[0];
    else {
      setSaleItems(newSaleItems);
      setShowSuccessFlashMessage(true);
      setSaleItemsCount(saleItemsCount - 1);
    }
  }

  const handleCloseDeletedSaleItemAnimation = (saleItem) => {
    addHtmlElementClass(document, `sale_item_${saleItem.id}_container`, 'close-sale-item');
  }


  // Funzione che gestisce la pubblicazione di un annuncio di vendita su un sale channel
  const handleUpdateSaleItem = (saleItem, listingAction, ingnoreFeesAlert) => {
    setDeferredListingToSubmit(null);

    if ((listingAction === 'delete' && saleItem.allow_deletion) || (listingAction !== 'delete' && saleItem.allow_changes)) {
      setSaleItemToUpdate({ oldSaleItem: saleItem, updatedSaleItem: saleItem });
      const newSaleItemSubStateAndValidation = handleUpdateSaleItemSubState(saleItem, listingAction)
      const newSaleItemSubState = newSaleItemSubStateAndValidation.newSubState;
      const validSaleItem = newSaleItemSubStateAndValidation.valid;

      if ((isDefined(listingAction) && validSaleItem) || (saleItem.state === 'draft' && !isDefined(listingAction))) {
        if (saleItem.state !== 'draft' || (isDefined(listingAction) && listingAction !== 'delete')) {
          const channelLink = saleChannelLink(saleItem);
          if (channelLink?.state !== 'completed' && channelLink?.handlePublishWithUncompleteLink) {
            channelLink.handlePublishWithUncompleteLink();
            setDeferredListingToSubmit({ saleItem: saleItem, listingAction: listingAction, ingnoreFeesAlert: ingnoreFeesAlert })
            return;
          }
        }

        if (listingAction === 'create' && saleItem.sale_channel.charges_fees_to_users &&
          (!feesAlertRead || !feesAlertRead[saleItem.sale_channel_id]) && !ingnoreFeesAlert)
          setSaleItemToPublish(saleItem);
        else {
          setSaleItemToPublish(null);
          handleShowActivityIndicator(saleItem, true, listingAction);

          const url = `/users/${saleItem.user_id}/sale_items/${saleItem.id}`;
          const body = {
            sale_item: {
              start_amount: saleItem.start_amount,
              sub_state: newSaleItemSubState,
              sale_method: saleItem.sale_method,
              sale_attributes: saleItem.sale_attributes,
              shipment_method: isDefined(saleItem.shipment_method?.id) ? saleItem.shipment_method : null
            }
          };

          if (isDefined(listingAction))
            body['listing_action'] = listingAction;

          fetch(url, {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          })
            .then((response) => {
              if (!response.ok)
                throw Error("An error occour during submit sale form");
              else
                return response.json();
            })
            .then((updatedSaleItem) => {
              if (listingAction === 'delete') {
                if (saleItem.state === 'draft') {
                  handleCloseDeletedSaleItemNotice(saleItem);
                } else {
                  const newUpdatedSaleItem = { ...saleItem, display_content: true, editable: false, sub_state: 'deleted' };
                  setTimeout(() => {
                    addHtmlElementClass(document, `happy_ending_${saleItem.id}_container`, 'd-flex');
                    removeHtmlElementClass(document, `happy_ending_${saleItem.id}_container`, 'd-none');
                    handleUpdateSaleItemParams({ ...newUpdatedSaleItem, render_deleted_happy_ending: true });
                    handleShowActivityIndicator(saleItem, false, listingAction);
                  }, 700);
                }
              } else {
                const newUpdatedSaleItem = { ...updatedSaleItem, display_content: true, editable: !isDefined(listingAction), sub_state: newSaleItemSubState };
                const render_happy_ending = ['create', 'relist'].includes(listingAction);
                handleUpdateSaleItemParams({ ...newUpdatedSaleItem, render_happy_ending: render_happy_ending });
                if (render_happy_ending) {
                  addHtmlElementClass(document, `happy_ending_${saleItem.id}_container`, 'd-flex');
                  removeHtmlElementClass(document, `happy_ending_${saleItem.id}_container`, 'd-none');
                  renderExplosion(saleItem, 'happy_ending_')
                }
                if (isDefined(listingAction)) {
                  setSaleItemToUpdate({ oldSaleItem: newUpdatedSaleItem, updatedSaleItem: newUpdatedSaleItem });
                  handleShowActivityIndicator(saleItem, false, listingAction);
                }
              }
            })
            .catch((error) => {
              handleShowActivityIndicator(saleItem, false, listingAction);
              console.error("ERROR:", error);
              setShowErrorModal(true);
            });
        }
      } else {
        handleShowActivityIndicator(saleItem, false, listingAction);
        handleUpdateSaleItemParams({ ...saleItem, display_content: true, editable: true, sub_state: newSaleItemSubState });
      }
    }
  }


  // Funzione che imposta il nuovo substate di un saleitem draft
  const handleUpdateSaleItemSubState = (saleItem, listingAction) => {
    let newSaleItemSubState = "just_created";

    if (
      isDefined(saleItem.start_amount) ||
      isDefined(saleItem.sale_method) ||
      isDefined(saleItem.shipment_method?.id) ||
      (isDefined(saleItem.sale_attributes) &&
        Object.keys(saleItem.sale_attributes).some(sale_attribute => sale_attribute !== 'title' && isDefined(saleItem.sale_attributes[sale_attribute])))
    )
      newSaleItemSubState = 'in_review'

    const validSaleItem = isValidSaleItem(saleItem, listingAction);
    if (validSaleItem)
      newSaleItemSubState = 'ready_for_listing';

    return { newSubState: newSaleItemSubState, valid: validSaleItem };
  }


  // Funzione che verifica se un sale item sia valido oppure no
  const isValidSaleItem = (saleItem, listingAction = null) => {
    if (listingAction === 'delete')
      return true;

    const validateParam = (condition, labelId, message) => {
      if (!condition) {
        if (isDefined(listingAction)) {
          setTimeout(() => {
            setHtmlElementContent(document, `status_message_container_${saleItem.id}`, message);
            addHtmlElementClass(document, labelId, 'color-red');
          }, 200);
        }
        return false;
      }
      return true;
    }

    let saleAttributesToValidate = saleAttributesBySaleItem(saleItem);

    setHtmlElementContent(document, `status_message_container_${saleItem.id}`, '');
    for (const saleAttribute of saleAttributesToValidate)
      removeHtmlElementClass(document, `${saleAttribute?.trait_name}_${saleItem.id}_label`, 'color-red');
    removeHtmlElementClass(document, `sale_method_${saleItem.id}_label`, 'color-red');
    removeHtmlElementClass(document, `start_amount_${saleItem.id}_label`, 'color-red');
    removeHtmlElementClass(document, `national_shipment_method_${saleItem.id}_label`, 'color-red');
    removeHtmlElementClass(document, `international_shipment_method_${saleItem.id}_label`, 'color-red');
    removeHtmlElementClass(document, `national_shipment_method_amount_${saleItem.id}_label`, 'color-red');
    removeHtmlElementClass(document, `international_shipment_method_amount_${saleItem.id}_label`, 'color-red');

    //Verifico che il sale method sia valorizzato
    if (!validateParam(isDefined(saleItem.sale_method), `sale_method_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.saleMethodRequired')))
      return false;

    // Verifico che lo start amount sia positivo
    if (!validateParam(isDefined(saleItem.start_amount) && saleItem.start_amount > 0, `start_amount_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.positiveStartAmount')))
      return false;

    // Verifico che tutti i campi obbligatori siano stati valorizzati
    const requiredSaleAttributes = saleAttributesToValidate.filter(sale_attribute => sale_attribute.required);
    for (const saleAttribute of requiredSaleAttributes) {
      if (!validateParam(isDefined(saleItem.sale_attributes[saleAttribute.trait_name]), `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.saleAttributeRequired').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`])))
        return false;
    }

    // Se l'utente ha impostato un metodo di spedizione per il suo annuncio di vendita
    if (isDefined(saleItem.shipment_method?.id)) {
      // Verifico che l'utente abbia impostato il metodo di spedizione dentro il territorio nazionale
      let shipmentMethodByCategory = safeShipmentMethod(saleItem.shipment_method, 'national');
      if (!validateParam(isDefined(shipmentMethodByCategory?.id), `national_shipment_method_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.nationalShipmentCourierRequired')))
        return false;

      if (!validateParam(isDefined(shipmentMethodByCategory.amount) && shipmentMethodByCategory.amount >= 0, `national_shipment_method_amount_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.nationalShipmentAmountRequired')))
        return false;

      // Verifico che l'utente abbia impostato il metodo di spedizione internazione se richiesto
      if (saleItem.shipment_method.id.indexOf('international') > -1) {
        shipmentMethodByCategory = safeShipmentMethod(saleItem.shipment_method, 'international');
        if (!validateParam(isDefined(shipmentMethodByCategory?.id), `international_shipment_method_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.internationalShipmentCourierRequired')))
          return false;

        if (!validateParam(isDefined(shipmentMethodByCategory.amount) && shipmentMethodByCategory.amount >= 0, `international_shipment_method_amount_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.internationalShipmentAmountRequired')))
          return false;
      }
    }

    // Verifico che lo start amount sia maggiore o uguale dell'eventuale minimo previsto
    const minAmount = saleItem.sale_channel.sale_methods.filter(sale_method => sale_method.method == saleItem.sale_method)[0].min_amount
    if (!validateParam(isDefined(minAmount) && saleItem.start_amount >= minAmount, `start_amount_${saleItem.id}_label`, I18n.t(`js.indexSaleItems.listingForm.validations.${saleItem.sale_method}MinStartAmount`).replace(':amount', parseAmount(minAmount, 2, false))))
      return false

    // Verifico che tutte le date siano al futuro
    // const dateSaleAttributes = saleAttributesToValidate.filter(sale_attribute => ['date', 'datetime'].includes(sale_attribute.value_type));
    // for (const saleAttribute of dateSaleAttributes) {
    //   if (isDefined(saleItem.sale_attributes[saleAttribute.trait_name])) {
    //     if (!validateParam(convertToLocal(saleItem.sale_attributes[saleAttribute.trait_name]) > new Date(), `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.dateInPast').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`])))
    //       return false;
    //   }
    // }

    // Verifico che tutti gli importi numerici non siano negativi
    const numericSaleAttributes = saleAttributesToValidate.filter(sale_attribute => ['float', 'integer', 'price'].includes(sale_attribute.value_type));
    for (const saleAttribute of numericSaleAttributes)
      if (isDefined(saleItem.sale_attributes[saleAttribute.trait_name])) {
        if (!validateParam(parseFloat(saleItem.sale_attributes[saleAttribute.trait_name]) > 0, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.positiveNumericSaleAttribute').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`])))
          return false;
      }

    //Verifico che se presente un min value venga rispettato
    const saleAttributesWithMinValue = saleAttributesToValidate.filter(sale_attribute => isDefined(sale_attribute.min_value));
    for (const saleAttribute of saleAttributesWithMinValue) {
      const value = saleItem.sale_attributes[saleAttribute.trait_name]
      if (isDefined(value)) {
        const minValue = parseFloat(saleAttribute.min_value);
        switch (saleAttribute.value_type) {
          case 'integer':
            if (!validateParam(value >= minValue, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.numericSaleAttributeMinValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', saleAttribute.min_value)))
              return false;
            break;
          case 'float':
          case 'price':
            if (!validateParam(value >= minValue, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.numericSaleAttributeMinValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', `${parseAmount(saleAttribute.min_value, 2, true)}€`)))
              return false;
            break;
          case 'string':
          case 'text':
            if (!validateParam(value.length >= minValue, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.stringSaleAttributeMinValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', saleAttribute.min_value)))
              return false;
            break;
          case 'date':
          case 'datetime':
            const minDate = now.clone().utc().add(saleAttribute.min_value.split(' ')[0], saleAttribute.min_value?.split(' ')[1]);
            const minDateUtc = minDate.format('YYYY-MM-DDTHH:mm')
            if (!validateParam(moment(value).isSameOrAfter(minDate.format('YYYY-MM-DD HH:mm')), `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.dateSaleAttributeMinValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', parseDateIsoFormat(convertToLocal(minDateUtc), "%d-%m-%Y, %H:%M"))))
              return false;
            break
          default:
            return false;
        }
      }
    }


    //Verifico che se presente un max value venga rispettato
    const saleAttributesWithMaxValue = saleAttributesToValidate.filter(sale_attribute => isDefined(sale_attribute.max_value));
    for (const saleAttribute of saleAttributesWithMaxValue) {
      const value = saleItem.sale_attributes[saleAttribute.trait_name]
      if (isDefined(value)) {
        const maxValue = parseFloat(saleAttribute.max_value);
        switch (saleAttribute.value_type) {
          case 'integer':
            if (!validateParam(value <= maxValue, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.numericSaleAttributeMaxValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', saleAttribute.max_value)))
              return false;
            break;
          case 'float':
          case 'price':
            if (!validateParam(value <= maxValue, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.numericSaleAttributeMaxValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', `${parseAmount(saleAttribute.max_value, 2, true)}€`)))
              return false;
            break;
          case 'string':
          case 'text':
            if (!validateParam(value.length <= maxValue, `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.stringSaleAttributeMaxValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', saleAttribute.max_value)))
              return false;
            break;
          case 'date':
          case 'datetime':
            const maxDate = now.clone().utc().add(saleAttribute.max_value.split(' ')[0], saleAttribute.max_value?.split(' ')[1])
            const maxDateUtc = maxDate.format('YYYY-MM-DDTHH:mm')
            if (!validateParam(moment(value).isSameOrBefore(maxDate.format('YYYY-MM-DD HH:mm')), `${saleAttribute.trait_name}_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.dateSaleAttributeMaxValue').replace(':saleAttribute', saleAttribute[`${I18n.locale}_name`]).replace(':amount', parseDateIsoFormat(convertToLocal(maxDateUtc), "%d-%m-%Y, %H:%M"))))
              return false;
            break;
        }
      }
    }

    // Solamente per ebay 
    if (saleItem.sale_channel.meta_name.toLowerCase().trim().indexOf('ebay') > -1 && isDefined(saleItem.sale_method)) {
      if (saleItem.sale_method.toLowerCase().trim() === 'auction') {
        // Se l'annuncio è stato listato con tramite asta, verifico che il prezzo di compralo subito, se presente, sia
        // maggiore o uguale di almeno il 40% del prezzo di partenza dell'asta
        if (isDefined(saleItem.sale_attributes['price'])) {
          const price = saleAttributesToValidate.filter(sale_attribute => sale_attribute.trait_name === 'price')[0];
          if (!validateParam(parseFloat(saleItem.sale_attributes['price']) >= saleItem.start_amount * 1.4, `price_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.ebayAuctionPrice').replace(':price', price[`${I18n.locale}_name`])))
            return false
        }

        // Se l'annuncio è stato listato con tramite asta con riserva, verifico che il prezzo di partenza dell'asta sia
        // inferiore al prezzo di riserva
        if (isDefined(saleItem.sale_attributes['auction_reserve_price'])) {
          const auctionReservePrice = saleAttributesToValidate.filter(sale_attribute => sale_attribute.trait_name === 'auction_reserve_price')[0];
          if (!validateParam(saleItem.start_amount < parseFloat(saleItem.sale_attributes['auction_reserve_price']), `auction_reserve_price_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.ebayAuctionReservePrice').replace(':auction_reserve_price', auctionReservePrice[`${I18n.locale}_name`])))
            return false;
        }

        // Se l'annuncio è stato listato con tramite asta con riserva, verifico che il prezzo di compralo subito sia
        // maggiore o uguale al prezzo di riserva dell'asta
        if (isDefined(saleItem.sale_attributes['price']) && isDefined(saleItem.sale_attributes['auction_reserve_price'])) {
          const price = saleAttributesToValidate.filter(sale_attribute => sale_attribute.trait_name === 'price')[0];
          const auctionReservePrice = saleAttributesToValidate.filter(sale_attribute => sale_attribute.trait_name === 'auction_reserve_price')[0];
          if (!validateParam(parseFloat(saleItem.sale_attributes['price']) > parseFloat(saleItem.sale_attributes['auction_reserve_price']), `price_${saleItem.id}_label`, I18n.t('js.indexSaleItems.listingForm.validations.ebayAuctionReservePriceAndPrice').replace(':price', price[`${I18n.locale}_name`]).replace(':auction_reserve_price', auctionReservePrice[`${I18n.locale}_name`])))
            return false;
        }

      } else {

        // Se i campi auto accept price e auto decline price sono valorizzati verifico che il loro valore sia
        // strettamente minore dello start amount
        const fixedPriceLabels = ['auto_accept_price', 'auto_decline_price']
        const fixedPriceSaleAttributes = saleAttributesToValidate.filter(sale_attribute => fixedPriceLabels.includes(sale_attribute.trait_name));
        for (const fixedPriceSaleAttribute of fixedPriceSaleAttributes)
          if (isDefined(saleItem.sale_attributes[fixedPriceSaleAttribute.trait_name]))
            if (!validateParam(parseFloat(saleItem.sale_attributes[fixedPriceSaleAttribute.trait_name]) < saleItem.start_amount, `${fixedPriceSaleAttribute.trait_name}_${saleItem.id}_label`, I18n.t(`js.indexSaleItems.listingForm.validations.ebayBestOfferEnable1`).replace(':saleAttribute', fixedPriceSaleAttribute[`${I18n.locale}_name`])))
              return false

        // Se i campi auto accept price e auto decline price sono valorizzati verifico che il valore di auto decline price
        // sia strettamente minore di auto accept price
        if (isDefined(saleItem.sale_attributes['auto_decline_price']) && isDefined(saleItem.sale_attributes['auto_accept_price'])) {
          const autoAcceptPrice = saleAttributesToValidate.filter(sale_attribute => sale_attribute.trait_name === 'auto_accept_price')[0];
          const autoDeclinePrice = saleAttributesToValidate.filter(sale_attribute => sale_attribute.trait_name === 'auto_decline_price')[0];
          if (!validateParam(parseFloat(saleItem.sale_attributes['auto_decline_price']) < parseFloat(saleItem.sale_attributes['auto_accept_price']), `auto_decline_price_${saleItem.id}_label`, I18n.t(`js.indexSaleItems.listingForm.validations.ebayBestOfferEnable2`).replace(':saleAttribute1', autoDeclinePrice[`${I18n.locale}_name`]).replace(':saleAttribute2', autoAcceptPrice[`${I18n.locale}_name`])))
            return false
        }
      }
    }

    setHtmlElementContent(document, `status_message_container_${saleItem.id}`, I18n.t(`js.indexSaleItems.statusMessage.${saleItem.sub_state}`));

    return true;
  }


  //Funzione che verifica se sia impostato un metodo di spedizione nazionale o internazionale
  const safeShipmentMethod = (shipmentMethod, category) => {
    if (isDefined(shipmentMethod) && isDefined(shipmentMethod[category]) && isDefined(shipmentMethod[category][0]))
      return shipmentMethod[category][0]
    return null
  }

  //Funzione che renderizza il popup di cancellazione di un saleitem
  const renderSaleItemToDestroyPopup = (saleItemToDestroy) => {
    return (
      <React.Fragment>
        {saleItemToDestroy?.sale_channel?.sale_methods?.filter(sale_method => sale_method.method == saleItemToDestroy?.sale_method)[0]?.enable_deletion ?
          <React.Fragment>
            {I18n.t('js.indexSaleItems.listingForm.deletionAlert.message').replace(':sale_channel', saleItemToDestroy?.sale_channel?.meta_name).replace(':serial_number', saleItemToDestroy?.grading?.extended_serial_number)}
          </React.Fragment>
          :
          <React.Fragment>
            <p>
              {I18n.t('js.indexSaleItems.listingForm.deletionAlert.messageNotDeletable').replaceAll(':sale_channel', saleItemToDestroy?.sale_channel?.meta_name)}
            </p>
            <p>
              {I18n.t('js.indexSaleItems.listingForm.deletionAlert.messageNotDeletable2').replaceAll(':sale_channel', saleItemToDestroy?.sale_channel?.meta_name)}
            </p>
            <p>
              {I18n.t('js.indexSaleItems.listingForm.deletionAlert.messageNotDeletable3').replaceAll(':sale_channel', saleItemToDestroy?.sale_channel?.meta_name)}
            </p>
            {saleChannelExternalLinksToRender(saleItemToDestroy, saleItemToDestroy?.sale_channel?.deletion_links)?.length > 0 &&
              <a href={saleChannelExternalLinksToRender(saleItemToDestroy, saleItemToDestroy.sale_channel.deletion_links)[0].value} target="_blank">
                {I18n.t('js.indexSaleItems.listingForm.deletionAlert.messageNotDeletableLink')}
              </a>
            }
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  //Funzione che renderizza i coriandoli di esplosione come animazione sul contenitore di un saleItem
  //parametri: saleItem, element (id dell'elemento che deve contenere i coriandoli), particles (numero di coriandoli)
  const renderExplosion = (saleItem, element, particles = 100) => {

    addHtmlElementClass(document, `${element}${saleItem.id}`, 'explosion')

    const explosion = getHtmlElement(document, `${element}${saleItem.id}`);

    const explosionWidth = explosion.offsetWidth;
    const explosionHeight = explosion.offsetHeight;

    const colors = ['#00a2dd', '#3FBAFF', '#00CADB', '#008FDB', '#009fe3', '#81d0ed', '#A06AF7', '#FF00FF', '#CFB0FF', '#883FFF'];

    for (var i = 0; i < particles; i++) {
      // positioning x,y of the particle on the circle (little randomized radius)
      const x = generateRandomNumber(0, explosionWidth);  // Distribuisci le particelle sull'intera larghezza
      const y = generateRandomNumber(0, explosionHeight); // Distribuisci le particelle sull'intera altezza
      const color = colors[generateRandomNumber(0, colors.length - 1)];
      // particle element creation (could be anything other than div)

      const particle = document.createElement('div');
      particle.classList.add('particle');
      particle.style.backgroundColor = color;
      particle.style.top = `${y}px`;
      particle.style.left = `${x}px`;

      // Genera un valore casuale per il movimento laterale tra 0 e 1
      const randomX = Math.random();
      particle.style.setProperty('--random-x', randomX);

      if (i == 0) { // no need to add the listener on all generated elements
        particle.addEventListener('animationend', () => {
          removeHtmlElementClass(document, `${element}${saleItem.id}`, 'explosion');
        });
      }

      appendHtmlElementChild(getHtmlElement(document, `${element}${saleItem.id}`), particle);
    }
  }


  // Funzione che restituisce i link esterni alle pagine web del sale channel da renderizzare a video sulla base
  // dell'eventuale marketplace preferito dall'utente per ebay
  const saleChannelExternalLinksToRender = (saleItem, links) => {
    const channelLink = saleChannelLink(saleItem);
    return links?.filter(link => !channelLink?.favorite_marketplace || !link.marketplace || link.marketplace === channelLink.favorite_marketplace);
  }


  // Funzione che ritorna il collegamento http che l'utente ha (eventualmente) instaurato fino a quel momento
  // con un determinato sale channel
  const saleChannelLink = (saleItem) => {
    return saleChannelsLinks ? saleChannelsLinks[saleItem?.sale_channel?.meta_name] : null;
  }



  return (
    <div>
      <div className="row w-100 p-0 mx-0 mt-0 mb-5">
        {saleItems.map((saleItem, i) => {
          const channelLink = saleChannelLink(saleItem);

          return <div key={saleItem.id} id={`sale_item_${saleItem.id}_container`}
            className="sale_item_container col-12 d-block d-md-flex my-3 px-3 px-md-0"
          // style={{ animation: `scale-up 0.5s ease-out ${0.100 * (i % saleItemsAnimationDivider)}s forwards` }}
          >
            <div className="d-flex d-md-none align-items-start justify-content-start pb-2 px-2">
              <img
                src={window.location.origin + `/images/icons/blue/arrow-${saleItem.display_content ? 'up' : 'down'}.svg`}
                alt="" width="18px"
                onClick={() => {
                  handleUpdateSaleItemParams({
                    ...saleItem,
                    display_content: !saleItem.display_content
                  })
                  if (!saleItem.display_content)
                    setTimeout(() => scrollHtmlElementIntoView(document, `sale_item_${saleItem.id}_content`, false), 2 * (600 / 3))
                }} />
            </div>


            <div className="w-100 p-0">
              <div
                className={`row w-100 p-0 m-0 align-items-center border-aiG-light-gray-imp br-8px ${!saleItem.render_deleted_happy_ending ? 'cursor-pointer on-hover-bg-lg-aig-light-gradient' : ''}`}
                onClick={(e) => {
                  if (!saleItem.render_deleted_happy_ending) {
                    if (window.innerWidth >= 768) {
                      handleUpdateSaleItemParams({ ...saleItem, display_content: !saleItem.display_content })
                      e.stopPropagation()
                    }
                    if (!saleItem.display_content)
                      setTimeout(() => scrollHtmlElementIntoView(document, `sale_item_${saleItem.id}_content`, false), 2 * (600 / 3))
                  }
                }}
              >
                <div className="col-5 col-md-4 col-xl-2 col-xxl-1dot5 bg-aig-gradient color-white
                d-flex justify-content-start justify-content-sm-center justify-content-xl-start align-items-center
                px-0 minH-40px-imp z-index-10 position-relative
                br-top-left-8px br-bottom-left-0px br-bottom-right-8px
                br-bottom-left-md-8px br-bottom-right-md-0px"
                  id={`sale_item_number_container_${saleItem.id}`}
                >
                  <div className="d-flex ml-4">
                    <img
                      src={window.location.origin + '/images/icons/white/aigrading_logo.svg'}
                      className="d-none d-sm-flex"
                      alt="" width="18px" />

                    <div className="mt-1 ml-2 ml-sm-0 ml-md-1 ml-xl-2">
                      <b className={`font-size-xxxl-16px ${!saleItem.grading.serial_number ? 'd-none' : ''}`}
                        id={`sale_item_number_${saleItem.id}`}>
                        {saleItem.grading.extended_serial_number}
                      </b>
                    </div>
                  </div>

                  <div className="position-absolute z-index-99 right-negative-18px">
                    <div className="d-flex flex-directions-column bg-aig-gradient p-2px br-50perc">
                      <div
                        className="d-flex justify-content-center flex-fill align-items-center br-50perc bg-white grading-container-medium">
                        <img src={saleItem.sale_channel?.thumb_icon_url} className="opacity-1-imp" alt="" width='20px' />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-2 col-md-4 col-xl-8 col-xxl-9 z-index-10 px-0">

                  <div className="d-none d-xl-flex justify-content-between align-items-center px-0 px-md-2 px-xl-4">
                    <SaleItemDetails
                      saleItem={saleItem}
                    />
                  </div>
                </div>

                <IconTooltip
                  tooltipContent={
                    saleItem.state !== 'draft' && saleItem.pending_actions_count > 0 && isDefined(channelLink?.uncompleteLinkAlertMessage) ?
                      channelLink.uncompleteLinkAlertMessage
                      :
                      I18n.t(`js.indexSaleItems.stateTooltip.${saleItem.state}`).replace(':date', saleItem.state === 'scheduled' ? saleItem.schedule_date : saleItem.expiration_date).replace(':hour', saleItem.state === 'scheduled' ? saleItem.schedule_time : saleItem.expiration_time)
                  }
                  customComponentToRenderCssClass={"col-5 col-md-4 col-xl-2 col-xxl-1dot5 px-0 color-white d-flex justify-content-center align-items-center text-center minH-40px-imp z-index-99 position-relative br-top-right-8px br-bottom-left-8px br-bottom-right-0px br-bottom-left-md-0px br-bottom-right-md-8px"}
                  customComponentToRenderStyle={{ backgroundColor: saleItemColorState(saleItem.state) }}
                  customComponentToRender={
                    <React.Fragment>
                      {/* Se il saleitem ha ancora almeno un ordine da processare su mercurio allora renderizzo un'icona che lo informa che qualcosa sta avvenendo */}
                      {
                        saleItem.state !== 'draft' && saleItem.pending_actions_count > 0 &&
                        (
                          channelLink?.state !== 'completed' ?
                            <div className="sale_item_alert_icon">
                              <img
                                src={window.location.origin + '/images/icons/alert-outline.svg'}
                                alt="" height="40px" />
                            </div>
                            :
                            <div className="sale_item_hourglass_icon">
                              <img
                                src={window.location.origin + '/images/icons/blue/hourglass.svg'}
                                alt="" width="26px" />
                            </div>
                        )
                      }
                      <div className="my-0 py-0 text-truncate">
                        <b className="color-white text-truncate">
                          {I18n.t(`js.indexSaleItems.states.${saleItem.state}`).toUpperCase()}
                        </b>
                      </div>
                    </React.Fragment>
                  }
                />

                <div
                  className="col-12 d-block d-md-flex d-xl-none justify-content-between align-items-center py-2 pr-1 text-center text-md-left">
                  <SaleItemDetails
                    saleItem={saleItem}
                  />
                </div>
              </div>

              <div
                className={`row slide-animation-container slide-${saleItem.display_content ? 'down' : 'up'} w-100 p-0 m-0 mt-minus-5px`}
                id={`sale_item_${saleItem.id}_content`}>
                <div className="col-xl-2 col-xxl-1dot5 d-none d-lg-flex"></div>
                {saleItem.grading && (
                  <div
                    className={`col-12 col-sm-12 col-md-12 col-xl-10 col-xxl-10dot5
                  border-left-bottom-right-aiG-light-gray-imp
                  border-bottom-radius-8px px-0 pt-2px-imp shadow-on-left-bottom-right ${saleItem.removing ? 'removing' : ''}
                `}>
                    <div className="row w-100 px-0 m-0">
                      <div
                        className="d-flex col-12 col-sm-4 col-lg-3 col-xl-2 flex-column justify-content-start border-right-sm-aiG-light-gray-imp border-bottom-aiG-light-gray-imp border-bottom-sm-none py-2">
                        <ShowBlueprintImageFrontImage
                          size={'shrinked_medium'}
                          product={saleItem.grading}
                          blueprintImage={{ ...saleItem.grading, encasing_id: 'gradable_product' }}
                          cursor={'auto'}
                          additionalClasses={(saleItem.blueprint_image.blueprint?.category?.name?.toLowerCase() === 'booster pack' ? "shrinked_medium-image-graded-booster-pack m-auto" : "shrinked_medium-image-graded-card m-auto")}
                        />

                        <div className="text-center">
                          <button
                            type="button"
                            id={`aig-certificate_${saleItem.grading.id}`}
                            className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none my-1 text--white-space-no-wrap px-3 font-size-12px"
                            onClick={(e) => {
                              e.stopPropagation()
                              setSaleItemToShowGradingCertificate(saleItem)
                              setShowCertificate(true)
                            }}
                          >
                            <img
                              src={window.location.origin + '/images/icons/white/aigrading_logo.svg'}
                              alt="" width="15px" />
                            {I18n.t('js.showCertificateModal.certificate').toUpperCase()}
                          </button>
                        </div>
                      </div>

                      <div
                        className="col-12 col-sm-8 col-lg-9 col-xl-10 d-flex flex-column justify-content-between px-0">
                        {/* Form di editing del sale item */}
                        <SaleForm
                          saleItem={saleItem}
                          handleUpdateSaleItem={handleUpdateSaleItem}
                          now={now}
                          safeShipmentMethod={safeShipmentMethod}
                          saleItemToUpdate={saleItemToUpdate}
                          setSaleItemToUpdate={setSaleItemToUpdate}
                          saleChannelsLinks={saleChannelsLinks}
                        />

                        {/* Status message e bottoni per editare o pubblicare il sale item  */}
                        <div className="d-block d-xl-flex justify-content-between align-items-center px-4">
                          {/* Status message */}
                          <div className="pt-2 pb-1 pb-xl-2 sale-item-status-message-container">
                            {
                              saleItem.state === 'draft' || saleItem.editable ?
                                <span className="color-gray-4" id={`status_message_container_${saleItem.id}`}>
                                  {I18n.t(`js.indexSaleItems.statusMessage.${saleItem.sub_state}`)}
                                </span>
                                :
                                isDefined(channelLink?.uncompleteLinkAlertMessage) ?
                                  <span className="text-aiBlue">
                                    {channelLink.uncompleteLinkAlertMessage}
                                  </span>
                                  :
                                  isDefined(saleItem.listing_url) &&
                                  <a href={saleItem.listing_url} target="_blank" className="listing-url blue-label">
                                    {I18n.t("js.indexSaleItems.viewListingOn").replace(":sale_channel", saleItem.sale_channel.meta_name)}
                                  </a>
                            }
                          </div>

                          {/* Bottoni */}
                          <div
                            className="d-flex flex-wrap justify-content-between justify-content-md-end pb-2 pt-1 pt-xl-2">
                            {
                              saleItem.state !== 'draft' && saleItem.editable ?
                                <SaleItemActionButton
                                  condition={saleItem.allow_changes}
                                  button={
                                    <React.Fragment>
                                      <button
                                        type="button"
                                        id={`revert_sale_item_${saleItem.id}`}
                                        className="sale_item_cta bg-red color-white text-weight-500 border-none my-1 text--white-space-no-wrap px-3 font-size-12px mr-2"
                                        onClick={(e) => {
                                          handleRevertSaleItem(saleItem)
                                        }}
                                      >
                                        {I18n.t('js.indexSaleItems.listingForm.cancel').toUpperCase()}
                                      </button>
                                    </React.Fragment>
                                  }
                                />
                                :
                                <SaleItemActionButton
                                  condition={saleItem.allow_deletion}
                                  button={
                                    <React.Fragment>
                                      <button
                                        type="button"
                                        id={`delete_sale_item_${saleItem.id}`}
                                        className="sale_item_cta bg-red color-white text-weight-500 border-none my-1 text--white-space-no-wrap px-3 font-size-12px mr-2"
                                        onClick={(e) => {
                                          handleDeleteSaleItem(saleItem)
                                        }}
                                      >
                                        {I18n.t('js.indexSaleItems.listingForm.deleteListing').toUpperCase()}
                                      </button>
                                    </React.Fragment>
                                  }
                                />
                            }

                            {
                              saleItem.state === 'draft' ?
                                <SaleItemActionButton
                                  condition={saleItem.allow_changes}
                                  button={
                                    <React.Fragment>
                                      <button
                                        type="button"
                                        id={`publish_sale_item_${saleItem.id}`}
                                        className="sale_item_cta bg-intense-blue-imp color-white text-weight-500 border-none my-1 text--white-space-no-wrap px-3 font-size-12px"
                                        onClick={(e) => {
                                          handleUpdateSaleItem(saleItem, 'create')
                                        }}
                                      >
                                        {I18n.t('js.indexSaleItems.listingForm.publishListing').toUpperCase()} {saleItem.sale_channel.meta_name.toUpperCase()}
                                      </button>
                                    </React.Fragment>
                                  }
                                />
                                :
                                (
                                  saleItem.editable ?
                                    <SaleItemActionButton
                                      condition={saleItem.allow_changes}
                                      button={
                                        <React.Fragment>
                                          <button
                                            type="button"
                                            id={`update_sale_item_${saleItem.id}`}
                                            className="sale_item_cta bg-intense-blue-imp color-white text-weight-500 border-none my-1 text--white-space-no-wrap px-3 font-size-12px"
                                            onClick={(e) => {
                                              handleUpdateSaleItem(saleItem, saleItem.state === 'expired' ? 'relist' : 'update')
                                            }}
                                          >
                                            {
                                              saleItem.state === 'expired' ?
                                                `${I18n.t('js.indexSaleItems.listingForm.publishListing').toUpperCase()} ${saleItem.sale_channel.meta_name.toUpperCase()}`
                                                :
                                                `${I18n.t('js.indexSaleItems.listingForm.updateListing').toUpperCase()} ${saleItem.sale_channel.meta_name.toUpperCase()}`
                                            }
                                          </button>
                                        </React.Fragment>
                                      }
                                    />
                                    :
                                    <SaleItemActionButton
                                      condition={saleItem.allow_changes}
                                      button={
                                        <React.Fragment>
                                          <button
                                            type="button"
                                            id={`edit_sale_item_${saleItem.id}`}
                                            className="sale_item_cta bg-intense-blue-imp color-white text-weight-500 border-none my-1 text--white-space-no-wrap px-3 font-size-12px"
                                            onClick={(e) => {
                                              handleUpdateSaleItemParams({ ...saleItem, editable: true })
                                            }}
                                          >
                                            {I18n.t('js.indexSaleItems.listingForm.editListing').toUpperCase()}
                                          </button>
                                        </React.Fragment>
                                      }
                                    />
                                )
                            }

                            {/* Activity Indicator */}
                            {/* <div className="d-none align-items-center text-intense-blue my-1 ml-2"
                              id={`activity_indicator_${saleItem.id}`}>
                              <span className="mr-2" id={`activity_indicator_${saleItem.id}_message`}></span>
                              <div className="spinner-border size-1-5rem-imp" role="status" />
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="d-none sale-item-happy-ending-overlay bg-aig-gradient-light"
                        id={`happy_ending_${saleItem.id}_container`}>
                        <React.Fragment>
                          {saleItem.render_happy_ending &&
                            <div id={`happy_ending_${saleItem.id}`}>
                              <SaleItemHappyEnding
                                saleItem={saleItem}
                                handleUpdateSaleItemParams={handleUpdateSaleItemParams}
                              />
                            </div>
                          }
                          {saleItem.render_deleted_happy_ending &&
                            <div id={`deleted_happy_ending_${saleItem.id}`}>
                              <SaleItemDeletedHappyEnding
                                handleCloseDeletedSaleItemNotice={handleCloseDeletedSaleItemNotice}
                                handleCloseDeletedSaleItemAnimation={handleCloseDeletedSaleItemAnimation}
                                saleItem={saleItem}
                              />
                            </div>
                          }
                        </React.Fragment>
                      </div>
                      <div
                        className="d-none flex-directions-column sale-item-activity-overlay border-right-sm-aiG-light-gray-imp border-bottom-aiG-light-gray-imp border-bottom-sm-none py-2"
                        id={`activity_indicator_${saleItem.id}`}
                      >
                        <div>
                          <span className="sale-item-activity-indicator-text"
                            id={`activity_indicator_${saleItem.id}_message`}></span>
                        </div>
                        <div className="mt-4 spinner-border sale-item-activity-indicator" role="status" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        })}
      </div>

      {/* Popup che informa l'utente, prima della pubblicazione di un nuovo annuncio, che il sale channel in questione
          potrebbe applicare delle commissioni sulle sua nuova inserzione */}
      {
        isDefined(saleItemToPublish) &&
        <Modal show={isDefined(saleItemToPublish)} onHide={() => setSaleItemToPublish(null)} animation={false} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{I18n.t('js.indexSaleItems.listingForm.publishAlert.title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {I18n.t('js.indexSaleItems.listingForm.publishAlert.text_1').replaceAll(':sale_channel', saleItemToPublish?.sale_channel?.meta_name)}
              {
                saleChannelExternalLinksToRender(saleItemToPublish, saleItemToPublish?.sale_channel?.fees_links)?.length > 0 &&
                I18n.t('js.indexSaleItems.listingForm.publishAlert.text_2').replaceAll(':sale_channel', saleItemToPublish?.sale_channel?.meta_name)
              }&nbsp;

              {
                saleChannelExternalLinksToRender(saleItemToPublish, saleItemToPublish?.sale_channel?.fees_links)?.length > 0 &&
                <React.Fragment>
                  {
                    saleChannelExternalLinksToRender(saleItemToPublish, saleItemToPublish?.sale_channel?.fees_links)?.length == 1 ?
                      <React.Fragment>
                        <a href={saleChannelExternalLinksToRender(saleItemToPublish, saleItemToPublish?.sale_channel?.fees_links)[0].value} target="_blank">
                          {I18n.t('js.indexSaleItems.listingForm.publishAlert.text_3')}
                        </a>.&nbsp;
                        {I18n.t('js.indexSaleItems.listingForm.publishAlert.text_5')}
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {I18n.t('js.indexSaleItems.listingForm.publishAlert.text_4')}&nbsp;
                        {I18n.t('js.indexSaleItems.listingForm.publishAlert.text_5')}

                        <div className="mt-4">
                          <div className="d-flex justify-content-start align-items-end mb-2">
                            <h4 className="mr-2">{I18n.t('js.indexSaleItems.listingForm.publishAlert.fees')}</h4>
                            <div className="pb-2">
                              <img src={saleItemToPublish.sale_channel.thumb_logo_url} width="70px"></img>
                            </div>
                          </div>
                          {
                            saleChannelExternalLinksToRender(saleItemToPublish, saleItemToPublish?.sale_channel?.fees_links).map((feesLink, index) => {
                              return <p key={`feesLink_${index}`}>
                                <a href={feesLink.value} target="_blank">
                                  {
                                    feesLink.name.indexOf('private') > -1 ?
                                      I18n.t('js.indexSaleItems.listingForm.publishAlert.privateSellerFeesLink')
                                      :
                                      feesLink.name.indexOf('professional') > -1 ?
                                        I18n.t('js.indexSaleItems.listingForm.publishAlert.professionalSellerFeesLink')
                                        :
                                        feesLink.value
                                  }
                                </a>
                              </p>
                            })
                          }
                        </div>
                      </React.Fragment>
                  }
                </React.Fragment>
              }
            </div>


            <div className="mt-4">
              <input
                type="checkbox"
                className="feesCheckbox cursor-pointer mb-2"
                id="feesCheckbox"
                onClick={() => {
                  const newFeesAlertRead = isDefined(feesAlertRead) ? { ...feesAlertRead } : {};
                  newFeesAlertRead[saleItemToPublish.sale_channel_id] = !newFeesAlertRead[saleItemToPublish.sale_channel_id];
                  setFeesAlertRead(newFeesAlertRead);
                  window.localStorage.setItem('feesAlertRead', JSON.stringify(newFeesAlertRead));
                }}
              />
              &nbsp;
              <label className="ml-1 cursor-pointer font-weight-normal font-style-italic" htmlFor="feesCheckbox">
                {I18n.t('js.indexSaleItems.listingForm.publishAlert.checkbox')}
              </label>
            </div>

            <div className="d-flex justify-content-between w-100 mx-0 mt-4">
              <div>
                <button
                  type="button"
                  className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                  onClick={() => setSaleItemToPublish(null)}>
                  {I18n.t('js.common.button.cancel').toUpperCase()}
                </button>
              </div>

              <div>
                <button
                  type="button"
                  className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                  onClick={() => handleUpdateSaleItem(saleItemToPublish, 'create', true)}>
                  {I18n.t('js.indexSaleItems.listingForm.publishListing').toUpperCase()} {saleItemToPublish?.sale_channel?.meta_name.toUpperCase()}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }

      <GradingCertificate
        originalGradingCertificate={saleItemToShowGradingCertificate ? saleItemToShowGradingCertificate.grading : ''}
        originalBlueprintImage={saleItemToShowGradingCertificate ? saleItemToShowGradingCertificate.blueprint_image : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />

      {/* Popup di alert per la cancellazione degli annunci di vendita */}
      <AlertPopup
        showAlertPopup={isDefined(saleItemToDestroy)}
        onSuccess={() => handleRedirectSaleItemToDelete(saleItemToDestroy)}
        onDiscard={() => setSaleItemToDestroy(null)}
        popupTitle={I18n.t('js.indexSaleItems.listingForm.deletionAlert.title')}
        popupContent={renderSaleItemToDestroyPopup(saleItemToDestroy)}
        cancelButtonText={!saleItemToDestroy?.sale_channel?.sale_methods?.filter(sale_method => sale_method.method == saleItemToDestroy.sale_method)[0]?.enable_deletion ? null : I18n.t('js.common.button.cancel').toUpperCase()}
        confirmButtonText={`${!saleItemToDestroy?.sale_channel?.sale_methods?.filter(sale_method => sale_method.method == saleItemToDestroy.sale_method)[0]?.enable_deletion ?
          saleItemToDestroy?.listing_url ?
            I18n.t('js.indexSaleItems.listingForm.deletionAlert.link').toUpperCase() :
            I18n.t('js.indexSaleItems.listingForm.deletionAlert.okButton').toUpperCase() :
          I18n.t('js.common.button.confirm').toUpperCase()}`}
      />

      {/* Flash message per l'avvenuta cancellazione degli annunci di vendita */}
      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
        successMessage={I18n.t('js.indexSaleItems.listingForm.deletionAlert.flash')}
      />
    </div>
  );
};

export default SaleItemsList;